import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants, getSelectedContent, KEY_EVENT_VALUES, checkForSelectedLinkId, checkIfSelectionIsInsertion } from "../../src/utils";
import randomUUIDGenerator from '../../src/utils/randomUUIDGenerator.js';

const {
  rightClickOptions: { EDIT_LINK_KEY },
  htmlElement: { SPAN, LINK_SPAN, PARAGRAPH },
  class: { REF, WK_KEYWORD_REF },
  command: { CLICK },
  COMMANDS: { CMD_TRACK_CHANGES },
  event: { KEYDOWN, KEYUP, Cut, Delete },
  helperAttributes: { CONTENTEDITABLE, TRACK_CHANGES_EDITING, TYPE_OF, LINK_HREF, RESOURCE, DATA_CITATION_ID, NUMBERED_CITATION },
  PLUGINS: { RELEASE_NOTES, TRACK_CHANGES, TRACKCHANGE_EDITING },
  htmlAttributes: { CLASS, ID, REL, ABOUT },
  linksTo,
  attributeWebLink,
  localStorageItem: { RHP_CITATION_REF_CLICK },
} = CkeditorConstants;

const {
  BACKSPACE,
  CTRL,
  DELETE,
  LEFT_ARROW,
  RIGHT_ARROW,
  SHIFT_LEFT,
  ENTER
} = KEY_EVENT_VALUES;

export default class InsertWebEmailLinkCommand extends Command {
  execute(data) {
    const editor = this.editor;
    let isTextMarkedInGreen = checkIfSelectionIsInsertion(editor);
    isTextMarkedInGreen = isTextMarkedInGreen || !data.value.textSelected;
    this.isCtrlPressed = false;
    const { model: { document: { selection: { anchor } } } } = editor;
    const isLinkAtStart = anchor?.isAtStart;
    const getChildNodes = anchor?.parent?._children?._nodes.find(node => node?.name === LINK_SPAN);

    // Update selection to found child node linkspan on right-click edit event and link start
    if (data.value?.isEditEvent && !data.value.fromMiniEditor && isLinkAtStart && getChildNodes) {
      editor.model.change(writer => {
        writer.setSelection(getChildNodes, 'on');
      });
    }

    editor.model.change(writer => {
      const baseHrefId = this.editor?.baseHrefId?.concat('#') || '';
      const baseHrefPathUrl = this.editor?.baseHrefPathUrl?.concat('/') || '';

      const id = randomUUIDGenerator();
      this.elementRemove = '';
      if (editor?.model?.document?.selection?.getFirstPosition()?.parent?.getAttribute(TYPE_OF) === attributeWebLink &&
        !data.value.fromMiniEditor) {
        this.elementRemove = editor.model.document.selection.getFirstPosition().parent;
        writer.remove(this.editor.model.document.selection.getFirstPosition().parent);
      } else if (editor?.model?.document?.selection?.focus?.textNode?.hasAttribute(LINK_HREF)) {
        this.elementRemove = this.editor.model.document.selection.focus.textNode;
        writer.remove(this.editor.model.document.selection.focus.textNode);
      } else if (editor?.model?.document?.selection?.getSelectedElement()?.getAttribute(TYPE_OF) === attributeWebLink &&
        !data.value.fromMiniEditor) {
        this.elementRemove = editor.model.document.selection.getSelectedElement();
        writer.remove(editor.model.document.selection.getSelectedElement());
      }

      const regexExpMail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      const regexExpWeb = /^[hH][tT]{2}[pP][sS]?:\/\//;
      if (regexExpMail.test(data.value.linkAddress)) {
        data.value.linkAddress = `mailto:${data.value.linkAddress}`;
      } else if (!regexExpWeb.test(data.value.linkAddress)) {
        data.value.linkAddress = `http://${data.value.linkAddress}`;
      }

      editor.model.schema.extend(LINK_SPAN, {
        allowAttributes: ['id', 'about', 'rel', 'typeof', 'class', 'resource']
      });

      let formats = {}
      const { children } = this.elementRemove && this.elementRemove.toJSON();
      if (this.elementRemove && children && children.length && children[0].attributes) {
        const retrieveData = children[0].attributes;
        ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'smallcaps'].forEach(item => {
          if (retrieveData[item]) {
            formats[item] = true;
          }
        });
      }
      if (localStorage.getItem(EDIT_LINK_KEY) !== 'linktoanotherdocument' || (this.elementRemove._children && typeof this.elementRemove._children._nodes[0] === 'object')) {
        const linkSpan = writer.createElement(LINK_SPAN);
        writer.insertText(data.value.linkText, formats, linkSpan);
        const attributes = {
          'id': id,
          'rel': linksTo,
          'typeof': attributeWebLink,
          'class': REF,
          'resource': data.value.linkAddress
        };
        if (!data.value.fromMiniEditor) {
          attributes['about'] = `${baseHrefPathUrl}${baseHrefId}${id}`;
        }
        writer.setAttributes(attributes, linkSpan);

        editor.plugins.get(TRACK_CHANGES_EDITING).markInsertion(editor.model.document.selection.getFirstRange());
        if (data.value.fromMiniEditor) {
          const parentEl = editor.model.document.selection.getFirstPosition().parent;
          const isResource = parentEl.getAttribute(RESOURCE);
          // if Childcount > 1 for cases where one or more links added after the current link
          // if Childcount = 0 or resource attr !==null for cases where no links present or edit link on existing
          if (parentEl.childCount > 1 && isResource) {
            editor.model.insertContent(linkSpan, parentEl, "after")
          } else if ((parentEl.childCount === 0 && data.value.isEditEvent) || isResource) {
            editor.model.insertContent(linkSpan, parentEl, "on")
          } else editor.model.insertContent(linkSpan, editor.model.document.selection);
        } else {
          if (data.value.isEditEvent && editor.commands.get(CMD_TRACK_CHANGES).value && editor.plugins.get(TRACK_CHANGES).isEnabled) {
            writer.insert(linkSpan, editor.model.document.selection.focus);
            const range = writer.createRangeOn(linkSpan);
            try {
              const linkElement = data.value.linkElement ? data.value.linkElement : this.elementRemove;
              editor.plugins.get(TRACK_CHANGES_EDITING).markInsertion(range, '', {
                commandParams: {
                  linkTextBeforeEdit: this.elementRemove._data ? this.elementRemove._data : this.elementRemove._children._nodes[0]._data,
                  linkAddressBeforeEdit: this.elementRemove.getAttribute(LINK_HREF) ? this.elementRemove.getAttribute(LINK_HREF) : this.elementRemove.getAttribute('resource'),
                  linkBeforeEdit: {
                    id: linkElement.getAttribute(ID),
                    about: linkElement.getAttribute(ABOUT),
                    rel: linkElement.getAttribute(REL),
                    typeofAtr: linkElement.getAttribute(TYPE_OF),
                    classAtr: linkElement.getAttribute(CLASS)
                  },
                  removeLinkFromTrackChanges: true,
                  isTextMarkedInGreen: isTextMarkedInGreen
                }
              });
            } catch {
              editor.plugins.get(TRACK_CHANGES_EDITING).markInsertion(range);
            }
          } else {
            const focusPos = editor.model.document.selection?.focus;
            const isInsideLinkSpan = focusPos?.parent?.is?.('element') && (
              focusPos.parent.name === LINK_SPAN ||
              (focusPos.parent.name === SPAN &&
                focusPos.parent.getAttribute?.('rel') === linksTo)
            );
            const safeInsertPos = (isInsideLinkSpan && focusPos.isAtEnd)
              ? writer.createPositionAfter(focusPos.parent)
              : focusPos;

            if (data.value.textSelected) {
              writer.insert(linkSpan, safeInsertPos);
              if (editor.commands.get(CMD_TRACK_CHANGES).value && editor.plugins.get(TRACK_CHANGES).isEnabled) {
                const rangeOnLinkSpan = writer.createRangeOn(linkSpan);
                editor.plugins.get(TRACK_CHANGES_EDITING).markInsertion(rangeOnLinkSpan, '',
                  {
                    commandParams: {
                      isTextMarkedInGreen: isTextMarkedInGreen
                    }
                  }
                );
              }
              writer.remove(editor.model.document.selection.getFirstRange());
            } else {
              writer.insert(linkSpan, safeInsertPos);
              if (editor.commands.get(CMD_TRACK_CHANGES).value && editor.plugins.get(TRACK_CHANGES).isEnabled) {
                const range = writer.createRangeOn(linkSpan);
                editor.plugins.get(TRACKCHANGE_EDITING).markInsertion(range, '', {
                  commandParams: {
                    isTextPresent: data.value.textSelected,
                    isTextMarkedInGreen: isTextMarkedInGreen
                  }
                });
              }
            }
          }
        }
      } else {
        const linkSpan = editor.model.document.selection.getFirstPosition().parent;
        writer.setAttributes({
          'typeof': attributeWebLink,
          'resource': data.value.linkAddress
        }, linkSpan);
      }
      localStorage.removeItem(EDIT_LINK_KEY);
    });

    editor.focus();
    editor.fire('insertwebemaillink');
    this.isEnabled = false;
    this.refresh();
  }

  refresh() {
    const { model, editing: { view: { domRoots, document } } } = this.editor;
    const editingRootDomElement = domRoots.get("main");
    this.listenTo(document, CLICK, () => {
      let element = model.document.selection.getFirstPosition().parent;
      if (element.getAttribute(REL) === linksTo && element.getAttribute(CLASS) === REF) {
        model.change(writer => {
          writer.setAttribute(CONTENTEDITABLE, 'true', element);
        });
      } else if (element.getAttribute(CLASS) === WK_KEYWORD_REF) {
        const keywordId = element.getAttribute(ID);
        if (keywordId && !window.location.href.includes('/preview/')) {
          const keyword = editingRootDomElement && editingRootDomElement.querySelector(`[id='${keywordId}']`);
          keyword && keyword.setAttribute(CONTENTEDITABLE, 'true');
        }
      }
    });

    this.listenTo(document, KEYDOWN, (event, data) => {
      const element = model.document.selection.getFirstPosition().parent;
      const { _children: { _nodes } } = element;
      const { isAtEnd, isAtStart } = model.document.selection.focus;
      const { document: { selection: { focus: { nodeAfter, nodeBefore } } } } = model;
      let isBackWardKey = (data) => (data.domEvent && data.keyCode === BACKSPACE.WHICH && data.domEvent.code === BACKSPACE.KEY);
      let isDeleteKey = (data) => (data.domEvent && data.keyCode === DELETE.WHICH && data.domEvent.code === DELETE.KEY);
      let isShiftKey = (data) => (data.domEvent && data.keyCode === SHIFT_LEFT.WHICH && data.domEvent.code === SHIFT_LEFT.CODE);
      let isEnterKey = (data) => (data.domEvent && data.keyCode === ENTER.WHICH && data.domEvent.code === ENTER.KEY);
      if (data.keyCode === CTRL.WHICH) {
        this.isCtrlPressed = true;
      }
      const contentSelected = getSelectedContent(this.editor);
      if (_nodes && _nodes.length > 0 && !contentSelected && !isCtrlZKey(data) && !this.isCtrlPressed) {
        _nodes.forEach(ele => {
          if (ele.getAttribute(CLASS) === REF && !isBackSpaceShiftDelete(data)) {
            model.change(writer => {
              writer.setAttribute(
                CONTENTEDITABLE,
                data.keyCode === LEFT_ARROW.WHICH || data.keyCode === RIGHT_ARROW.WHICH || isEnterKey ? 'true' : 'false',
                ele
              );
            });
          }
        });
      }
      if (element.getAttribute(REL) === linksTo && element.getAttribute(CLASS) === REF && !contentSelected && !isCtrlZKey(data) && !this.isCtrlPressed) {
        model.change(writer => {
          let isEditable = 'true';
          if (isAtEnd && !isBackWardKey(data)) {
            writer.setSelection(element, "after");
          } else if (isAtStart && !isDeleteKey(data)) {
            isEditable = 'false';
            writer.setSelection(element, "before");
          }
          writer.setAttribute(CONTENTEDITABLE, isEditable, element);
        });
      }

      const linkElement = nodeAfter?.getAttribute(REL) === linksTo && (nodeAfter.name != NUMBERED_CITATION || !nodeAfter?.getAttribute?.(CLASS)?.includes?.(RELEASE_NOTES))
        ? nodeAfter
        : null;

      if (linkElement && !contentSelected) {
        model.change(writer => {
          writer.setSelection(linkElement, isDeleteKey(data) ? 0 : "before");
        });
      }

      const nodeBeforeElement = nodeBefore && nodeBefore.getAttribute(CLASS) === WK_KEYWORD_REF;

      const nodeBeforeParent = nodeBefore
        && nodeBefore.parent
        && nodeBefore.parent.getAttribute(CLASS) === WK_KEYWORD_REF;

      const keywordElement = nodeBeforeElement ? nodeBefore : (nodeBeforeParent ? nodeBefore.parent : null);

      const nodeAfterParent = nodeAfter && nodeAfter.parent && nodeAfter.parent.getAttribute(CLASS) === WK_KEYWORD_REF
        ? nodeAfter.parent
        : null

      const currentkeyword = (nodeAfter && nodeAfter.getAttribute(CLASS) === WK_KEYWORD_REF)
        ? nodeAfter
        : nodeAfterParent;

      model.change(writer => {
        if (keywordElement) {
          const keyword = editingRootDomElement && editingRootDomElement.querySelector(`[id='${keywordElement.getAttribute(ID)}']`);
          keyword && keyword.setAttribute(CONTENTEDITABLE, isFunctionalKey(data, this.isCtrlPressed, contentSelected) || isBackWardKey(data) || data.keyCode === BACKSPACE.WHICH ? 'true' : 'false');
          if ((isDeleteKey(data) && !contentSelected) || (!isFunctionalKey(data, this.isCtrlPressed, contentSelected) && !isBackWardKey(data))) {
            writer.setSelection(keywordElement, "after");
          }
        } else if (currentkeyword) {
          writer.setAttribute(CONTENTEDITABLE, isFunctionalKey(data, this.isCtrlPressed, contentSelected) ? 'true' : 'false', currentkeyword);
          if (!this.isCtrlPressed && !contentSelected && !isShiftKey(data)) {
            writer.setSelection(currentkeyword, isDeleteKey(data) ? 0 : "before");
          }
        }
      });
    });

    //cut/delete events are only used for RHP citations
    [Cut, Delete].forEach((event) => {
      const rhpCitationRefClicked = JSON.parse(localStorage.getItem(RHP_CITATION_REF_CLICK));
      this.listenTo(document, event, (evt, data) => {
        const element = model.document.selection.getFirstPosition().parent;
        const { isAtEnd, isAtStart } = model.document.selection.focus;
        let isBackWardKey = (data) => (data.direction && data.direction === 'backward' && isAtStart);
        let isDeleteKey = (data) => (data.direction && data.direction === 'forward' && isAtEnd);
        const { _children: { _nodes } } = element;
        if (event === Delete && rhpCitationRefClicked) {
          const contentSelected = getSelectedContent(this.editor);
          const checkCitationEle = element.parent?.parent?.hasAttribute(DATA_CITATION_ID) && element.name === PARAGRAPH;
          if (!contentSelected && checkCitationEle && (isBackWardKey(data) || isDeleteKey(data))) {
            data.preventDefault();
            evt.stop();
          }
          if (contentSelected && checkCitationEle && _nodes?.length === 0) {
            data.preventDefault();
            evt.stop();
          }
        }
        if (event === Cut) {
          //When link is selected in RHP reference with some text or multiple link
          if (_nodes && _nodes.length > 0) {
            _nodes.forEach(ele => {
              const conditionToCheck = ele._children?._nodes?.length == 0;
              this.removeElement(model, ele, conditionToCheck);
            });
          }
          else {
            //When only link is selected in RHP reference
            const conditionToCheck = element._children?._nodes?.length == 0;
            this.removeElement(model, element, conditionToCheck);
          }
        }
      });
    });

    this.listenTo(document, KEYUP, (event, data) => {
      const { document: { selection: { focus: { textNode, nodeAfter, nodeBefore } } } } = model;
      const element = model.document.selection.getFirstPosition().parent;
      const { _children: { _nodes } } = element;
      const isPreviousNodeKeyword = (textNode && textNode.previousSibling && textNode.previousSibling.hasAttribute(CLASS) && (textNode.previousSibling.getAttribute(CLASS) === WK_KEYWORD_REF || textNode.previousSibling.getAttribute(CLASS) === REF)) || (nodeBefore && nodeBefore.previousSibling && nodeBefore.previousSibling.hasAttribute(CLASS) && nodeBefore.previousSibling.getAttribute(CLASS) === REF);
      const isnextNodeKeyword = (textNode && textNode.nextSibling && textNode.nextSibling.hasAttribute(CLASS) && textNode.nextSibling.getAttribute(CLASS) === WK_KEYWORD_REF) || (nodeAfter && nodeAfter.hasAttribute(CLASS) && nodeAfter.getAttribute(CLASS) === REF);
      if (isPreviousNodeKeyword || isnextNodeKeyword) {
        const nextNodeKeywordId = isnextNodeKeyword ? (textNode && textNode.nextSibling && textNode.nextSibling.hasAttribute(ID) && textNode.nextSibling.getAttribute(ID)) || (nodeAfter && nodeAfter.hasAttribute(ID) && nodeAfter.getAttribute(ID)) : null;
        const keywordId = isPreviousNodeKeyword ? (textNode && textNode.previousSibling && textNode.previousSibling.hasAttribute(ID) && textNode.previousSibling.getAttribute(ID)) || (nodeBefore && nodeBefore.previousSibling && nodeBefore.previousSibling.hasAttribute(ID) && nodeBefore.previousSibling.getAttribute(ID)) : nextNodeKeywordId;
        if (keywordId) {
          const keyword = editingRootDomElement && editingRootDomElement.querySelector(`[id='${keywordId}']`);
          keyword && keyword.setAttribute(CONTENTEDITABLE, 'true');
        }
      }
      if (data.keyCode === CTRL.WHICH) {
        this.isCtrlPressed = false;
      }
      try {
        const rhpCitationRefClicked = JSON.parse(localStorage.getItem(RHP_CITATION_REF_CLICK));
        if ((data.keyCode === 8 || data.keyCode === 46)) {
          const mapper = this.editor.editing.mapper;
          const childrenElem = rhpCitationRefClicked ? [...[...model.document.selection.getFirstPosition().getAncestors()].reverse().find(item => item.name === 'paragraph' && mapper.toViewElement(item)?.getAttribute?.(CLASS).includes('citation-text'))?.getChildren()] : model.document.selection.getFirstPosition().getAncestors().reverse();
          childrenElem?.forEach(ele => {
            this.removeElement(model, ele, ele.isEmpty);
          });
          //remove empty span on selecting whole P or element with backspace/delete action from document editor
          !rhpCitationRefClicked && _nodes?.length && _nodes.forEach(element => {
            this.removeElement(model, element, element.isEmpty);
          });
        }
      } catch (ex) {
        console.log(ex);
      }
    });
  }

  removeElement(model, element, condition) {
    if (element.getAttribute(CLASS) === REF && (element.name === SPAN || element.name === LINK_SPAN) && condition) {
      model.change((writer) => {
        writer.remove(element);
      });
    }
  }
}

/**
* Check if keydown is back space / shift / delete
* @param { CKEditor5 } data
* @returns { boolean }
*/
const isBackSpaceShiftDelete = (data) => {
  let isBackWardKey = data.domEvent && data.keyCode === BACKSPACE.WHICH && data.domEvent.code === BACKSPACE.KEY;
  let isDeleteKey = data.domEvent && data.keyCode === DELETE.WHICH && data.domEvent.code === DELETE.KEY;
  let isShiftKey = data.domEvent && data.keyCode === SHIFT_LEFT.WHICH && data.domEvent.code === SHIFT_LEFT.CODE;
  return isBackWardKey || isDeleteKey || isShiftKey;
}

/**
 * Check if keydown is left arrow / right arrow / ctrl / shift / delete
 * @param { CKEditor5 } data
 * @param { boolean } isCtrlPressed
 * @param { string } contentSelected
 * @returns { boolean }
 */
const isFunctionalKey = (data, isCtrlPressed, contentSelected) => {
  let isDeleteKey = data.domEvent && data.keyCode === DELETE.WHICH && data.domEvent.code === DELETE.KEY;
  let isShiftKey = data.domEvent && data.keyCode === SHIFT_LEFT.WHICH && data.domEvent.code === SHIFT_LEFT.CODE;
  return data.keyCode === LEFT_ARROW.WHICH || data.keyCode === RIGHT_ARROW.WHICH || isCtrlPressed || contentSelected || isDeleteKey || isShiftKey;
}

const isCtrlZKey = (data) => {
  return data.ctrlKey && data.keyCode == 90;
}
